import { useId } from 'react'
import styles from './RaspadinhaPublicAddressFields.module.css'

export type RaspadinhaPublicAddressFormState = {
  postalCode: string
  street: string
  streetNumber: string
  complement: string
  neighborhood: string
  city: string
  state: string
}

export const EMPTY_RASPADINHA_PUBLIC_ADDRESS: RaspadinhaPublicAddressFormState = {
  postalCode: '',
  street: '',
  streetNumber: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
}

type RaspadinhaPublicAddressFieldsProps = {
  value: RaspadinhaPublicAddressFormState
  onChange: (next: RaspadinhaPublicAddressFormState) => void
}

type AddressFieldKey = keyof RaspadinhaPublicAddressFormState

type AddressFieldConfig = {
  key: AddressFieldKey
  label: string
  placeholder: string
  autoComplete?: string
  inputMode?: 'text' | 'numeric'
  maxLength?: number
}

const ADDRESS_FIELDS: AddressFieldConfig[] = [
  {
    key: 'postalCode',
    label: 'CEP',
    placeholder: '00000-000',
    autoComplete: 'postal-code',
    inputMode: 'numeric',
    maxLength: 9,
  },
  {
    key: 'street',
    label: 'Rua',
    placeholder: 'Nome da rua',
    autoComplete: 'address-line1',
  },
  {
    key: 'streetNumber',
    label: 'Número',
    placeholder: 'Número da residência',
    autoComplete: 'off',
  },
  {
    key: 'complement',
    label: 'Complemento',
    placeholder: 'Apartamento, bloco, referência (opcional)',
    autoComplete: 'address-line2',
  },
  {
    key: 'neighborhood',
    label: 'Bairro',
    placeholder: 'Nome do bairro',
    autoComplete: 'off',
  },
  {
    key: 'city',
    label: 'Cidade',
    placeholder: 'Nome da cidade',
    autoComplete: 'address-level2',
  },
  {
    key: 'state',
    label: 'Estado',
    placeholder: 'UF',
    autoComplete: 'address-level1',
    maxLength: 2,
  },
]

export function RaspadinhaPublicAddressFields({
  value,
  onChange,
}: RaspadinhaPublicAddressFieldsProps) {
  const groupId = useId()

  const updateField = (key: AddressFieldKey, fieldValue: string) => {
    onChange({
      ...value,
      [key]: key === 'state' ? fieldValue.toUpperCase() : fieldValue,
    })
  }

  return (
    <fieldset className={styles.fieldset} aria-labelledby={groupId}>
      <legend id={groupId} className={styles.legend}>
        Endereço completo
      </legend>

      {ADDRESS_FIELDS.map((field) => {
        const inputId = `${groupId}-${field.key}`

        return (
          <div key={field.key} className={styles.field}>
            <label className={styles.label} htmlFor={inputId}>
              {field.label}
            </label>
            <input
              id={inputId}
              className={styles.input}
              type="text"
              name={field.key}
              autoComplete={field.autoComplete}
              inputMode={field.inputMode}
              maxLength={field.maxLength}
              value={value[field.key]}
              onChange={(event) => updateField(field.key, event.target.value)}
              placeholder={field.placeholder}
            />
          </div>
        )
      })}
    </fieldset>
  )
}
